<template>
  <div class="flex">
    <NFormGroup
      label="Name"
    >
      <NInput />
    </NFormGroup>
  </div>
</template>
